import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from 'react-oidc-context';
import { isPageSessionStale } from 'features/auth/utils/appRenderRule';
import { getAppLocale } from 'features/i18n/utils/getAppLocale';
import { useStartFlow } from 'features/loading';
import type { IdentityTokenUserSettings } from '@hub/common';

const signInLocale = (accessToken: string): string | undefined => {
  if (isPageSessionStale()) return undefined;
  try {
    return (
      jwtDecode<IdentityTokenUserSettings>(accessToken).locale ?? undefined
    );
  } catch {
    return undefined;
  }
};

/** Gives the start flow the language of the Identity token the sign-in uses
 *  as soon as that token arrives. Renders inside the oidc `AuthProvider`. */
export const StartFlowLocaleReporter = (): null => {
  const { user, isAuthenticated } = useAuth();
  const { active, setLocale } = useStartFlow();
  const accessToken = isAuthenticated ? user?.access_token : undefined;

  useEffect(() => {
    if (!active || !accessToken) return;
    const locale = signInLocale(accessToken);
    if (locale) setLocale(getAppLocale(locale));
  }, [active, accessToken, setLocale]);

  return null;
};
